import { z } from 'zod';
import { FacilityCapabilitySchema, FacilityRolePresetSchema } from './capability.schema.js';
/**
 * Facility Admin self-service user management (portal, `/me/facility/users/*`).
 *
 * The facility Admin (a login holding `ACCOUNT_MANAGE`) manages their own
 * facility's logins — the platform operator is not involved (Phase 22 §3.2
 * revision: facility-user management is the facility Admin's responsibility).
 * v1 offers the four role presets, not raw capability atoms (the raw editor is
 * the v1.x follow-up).
 */
export const FacilityUserRowSchema = z.object({
    userId: z.string(),
    email: z.string(),
    displayName: z.string().nullable(),
    capabilities: z.array(FacilityCapabilitySchema),
    /** Matching preset name, or null when the set is a bespoke (v1.x) grant. */
    preset: FacilityRolePresetSchema.nullable(),
    invitedAt: z.string(),
    /** No acceptedAt yet — invited but hasn't signed in. */
    pending: z.boolean(),
    /** The caller's own row — the UI blocks self-removal / self-demotion. */
    isSelf: z.boolean(),
});
export const FacilityUsersListResponseSchema = z.object({
    users: z.array(FacilityUserRowSchema),
});
export const FacilityInviteUserRequestSchema = z.object({
    email: z.string().email().max(254).toLowerCase(),
    displayName: z.string().min(1).max(120).trim(),
    preset: FacilityRolePresetSchema,
});
export const FacilityInviteUserResponseSchema = z.object({
    ok: z.literal(true),
    userId: z.string(),
    email: z.string(),
    newUser: z.boolean(),
});
export const FacilityUpdateUserRoleRequestSchema = z.object({
    preset: FacilityRolePresetSchema,
});
export const FacilityUserActionResponseSchema = z.object({ ok: z.literal(true) });
//# sourceMappingURL=users.schema.js.map